export const isTouchDevice = (): boolean => {
  return "ontouchstart" in document.documentElement;
};
